import { Box, Typography } from "@mui/material";
import React from "react";

const AnalyticsPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography>Analytics</Typography>
    </Box>
  );
};

export default AnalyticsPage;
